enum EModalVariant {
  TIGHT = 'tight',
  WIDE = 'wide',
}

export default EModalVariant;
